<template>
    <div v-if="tieneDatos" class="mini-criterios">
        <div v-for="clave in claves" :key="clave" class="mini-criterios__col"
            :title="`${nombres[clave] || clave}: ${valor(clave) === null ? '—' : valor(clave)}`">
            <div class="mini-criterios__track">
                <div class="mini-criterios__fill"
                    :style="{ height: altura(clave) + '%', background: colorPorPromedio(valor(clave)) }"></div>
            </div>
        </div>
    </div>
    <span v-else class="text-xs text-secondary">—</span>
</template>

<script>
import { computed } from "vue";
import { colorPorPromedio } from "../reputacionHelpers.js";

const CLAVES = ['fotos', 'informacion', 'disponibilidad', 'respuesta', 'etica'];

// Cinco barras verticales (una por criterio) para ver de un vistazo dónde falla
export default {
    name: "MiniCriterios",
    props: {
        criterios: { type: Object, default: null },
        nombres: { type: Object, default: () => ({}) },
    },
    setup(props) {
        const valor = (clave) => {
            const v = props.criterios ? props.criterios[clave] : null;
            return v === null || v === undefined ? null : Number(v);
        };
        const altura = (clave) => ((valor(clave) || 0) / 5) * 100;
        const tieneDatos = computed(() => CLAVES.some((c) => valor(c) !== null));

        return { claves: CLAVES, valor, altura, tieneDatos, colorPorPromedio };
    },
};
</script>

<style scoped>
.mini-criterios {
    display: inline-flex;
    align-items: flex-end;
    gap: 3px;
    height: 26px;
}

.mini-criterios__col {
    width: 7px;
    height: 100%;
    cursor: help;
}

.mini-criterios__track {
    position: relative;
    width: 100%;
    height: 100%;
    background: #F1F5F9;
    border-radius: 2px;
    overflow: hidden;
}

.mini-criterios__fill {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 2px;
}
</style>
